import React, { useEffect } from "react";

import { AuthGuard } from "components/auth-guard";
import { useAuth } from "contexts/auth-context";
import { AppLayout } from "layouts/app-layout";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { Heading2, Paragraph2 } from "ui/typography";

export const NotFoundContainer = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(ROUTES.LOGIN_PAGE);
    }
  }, [isAuthenticated]);

  return (
    <>
      {isAuthenticated && (
        <AuthGuard>
          <AppLayout>
            <Heading2>Not Found Page</Heading2>
            <Paragraph2>
              The page you are looking for does not exist.
            </Paragraph2>
          </AppLayout>
        </AuthGuard>
      )}
    </>
  );
};
